import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { isMobile } from 'react-device-detect'
import SVG from 'core/components/svg'
import { Row, Col } from 'core/components/ui'
import { font, greys, borderRadius, fontFamily } from 'assets/themes/theme-default'

const Wrapper = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  padding: ${isMobile ? '0' : '0 30px'};
`
const Title = styled.h1`
  color: ${greys.dark1};
  font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.bold.name},`}
    ${fontFamily.bold};
  font-size: ${font.size.lgxl};
  text-align: center;
  margin: ${isMobile ? '5px 0 10px' : '25px 0 25px'};
  line-height: ${isMobile && 'normal'};
  :after {
    background: ${props => props.theme.colors.color1.bg};
    width: 25px;
    height: 5px;
    content: ' ';
    display: block;
    margin: 15px auto;
  }
`

const SubTitleWrapper = styled.div`
  background: ${greys.light3};
  font-size: ${font.size.base};
  font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.italic.name},`}
    ${fontFamily.italic};
  line-height: ${isMobile && 'normal'};
  margin: ${isMobile ? '10px' : '0px auto 35px'};
  padding: ${isMobile ? '10px' : '15px'};
  border-radius: ${borderRadius.base};
  display: inline-block;
  // text-align: center;
`

const TitleIconWrapper = styled.div`
  width: ${isMobile ? '20px' : '30px'};
  height: ${isMobile ? '20px' : '30px'};
  margin: 0 auto;
`

const TitleIcon = styled(SVG)`
  fill: ${props => props.theme.colors.color1.bg};
  vertical-align: middle;
`

const MainContentWrapper = props => {
  const { children, title, subTitle, cssId } = props
  const { subtitle, icon } = subTitle
  return (
    <Wrapper>
      {title && (
        <Title id={cssId} data-test="main-content-wrapper-title">
          <span>{title}</span>
        </Title>
      )}
      {subtitle && (
        <Row type="flex" justify="center" gutter={30}>
          <SubTitleWrapper data-test="main-content-wrapper-subtitle">
            <Row type="flex" justify="left" gutter={13}>
              {icon && (
                <Col lg={3} xs={3}>
                  <TitleIconWrapper>
                    <TitleIcon svg={icon} />
                  </TitleIconWrapper>
                </Col>
              )}
              <Col lg={icon ? 21 : 24} xs={icon ? 21 : 24}>
                {subtitle}
              </Col>
            </Row>
          </SubTitleWrapper>
        </Row>
      )}
      {children}
    </Wrapper>
  )
}

MainContentWrapper.defaultProps = {
  title: '',
  subTitle: {},
  cssId: null,
  children: null
}
MainContentWrapper.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.shape({
    icon: PropTypes.shape(),
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.shape()])
  }),
  cssId: PropTypes.string,
  children: PropTypes.node
}

export default MainContentWrapper
